<template>
  <div
    class="container d-flex justify-content-center align-items-center loginContainer">
    <div class="myContainer pt-5 pb-5">
      <div class="mx-auto mb-3"
           style="width:75%">
        <b-img fluid
               :src="require('@assets/logo.svg')" />
      </div>
      <div style="width:50%"
           class="mx-auto mt-5">
        <b-form @submit="login">
          <div class="mx-auto my-2 text-center">
            <b-form-input
              v-model="email"
              class="myInput"
              type="text"
              placeholder="E-mail"
              :state="emailState" />
          </div>
          <div class="mx-auto my-2 text-center">
            <b-form-input
              v-model="password"
              class="myInput"
              type="password"
              placeholder="Password"
              :state="passwordState" />
          </div>
          <div class="mx-auto mt-5 text-center">
            <b-button type="submit"
                      class="myButton">
              Přihlásit se
            </b-button>
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AdminLogin',
  data() {
    return {
      email: '',
      password: '',
      emailState: null,
      passwordState: null
    };
  },
  created() {
    if (this.$auth.check('Permissions.AdminPanel.View')) {
      this.$router.replace({ name: 'admin.dashboard' });
    }
  },
  methods: {
    login(evt) {
      evt.preventDefault();
      this.$auth.options.loginData.url = '/auth/adminLogin';
      this.$auth.options.loginData.redirect = '/';
      this.$auth
        .login({
          email: this.email,
          password: this.password
        })
        .then((res) => {
          this.emailState = null;
          this.passwordState = null;
          localStorage.setItem('refresh_token', res.data.refreshToken);
        })
        .catch((err) => {
          this.emailState = false;
          this.passwordState = false;
          return Promise.resolve(err);
        });
    }
  }
};
</script>
<style lang="scss">
@import '@design/adminLayout.scss';
.loginContainer {
  height: 100vh;
}

.myContainer {
  background: $dp02;
  width: 350px;
  border-radius: 4px;
  box-shadow: 0 9px 19px rgba(0, 0, 0, 0.3), 0 7px 6px rgba(0, 0, 0, 0.22);
}
</style>
